/**
 * What the collapsed gateway row sends with, using the same shared rule
 * as the creative fill and the gateway's own generation amount.
 * For Media Devoted | Created By Ciro Autiero
 */
import { type DropGenGatewayLane, sendersForLane } from '@trafficpulse/shared';

import type { DraftSenderDefaults } from '../../../../drop-generator.types';

export interface SendsWith {
  /** The lane's own sender IDs, in list order. */
  names: string[];
  /** Names the AI adds on this lane — null when it writes none. */
  ai: number | null;
  /** The group the AI writes those names from — null when it writes none. */
  aiGroupId: string | null;
}

export function sendsWithFor(defaults: DraftSenderDefaults, lane: Pick<DropGenGatewayLane, 'senders'> | null): SendsWith {
  const { fixed, aiGroupId } = sendersForLane(defaults, lane);
  return { names: fixed, ai: aiGroupId !== null ? (lane?.senders.amount ?? defaults.amount) : null, aiGroupId };
}
